import { map } from 'rxjs/operators';
import RESTClient from 'signin-app/api/clients/rest-client';
import { ChildCheckout, transformGroups } from 'signin-app/child/models';
export default class ChildApi {
    static checkIn(options) {
        const { childId, ...params } = options;
        return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkins`, params);
    }
    static checkOut(childId, pin, kcData) {
        return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkout`, {
            pin,
            ...(kcData
                ? {
                    kinderConnectPhoto: kcData.photoBase64,
                    kinderConnectSignature: kcData.signatureBase64,
                    kinderConnectLatitude: kcData.latitude,
                    kinderConnectLongitude: kcData.longitude,
                }
                : {}),
        }).pipe(map(response => {
            return new ChildCheckout(response[0]);
        }));
    }
    static goHomeWithChildren(childId) {
        return RESTClient.getAuthenticatedObservable(`v2/childcheckins/gohomewith`, {
            childId,
        }).pipe(map((response) => {
            return transformGroups(response);
        }));
    }
}
